import React from 'react';
import GrassBlade from './grass-blade';

const GrassButton = () => {
    const blades = [
        { offset: 0, opacity: 1, duration:2000 },
        { offset: 0.5, opacity: 0.8, duration:1800 },
        { offset: 1, opacity: 0.6, duration:1600 },
        { offset: 1.5, opacity: 0.4, duration:1400 },
        { offset: 2, opacity: 0.2, duration:1200 },
    ];

    return (
        <button style={{ background: 'none', border: 'none', padding: '20px', cursor: 'pointer' }}>
            <svg width="200" height="200" xmlns="http://www.w3.org/2000/svg">
                {blades.map((blade, index) => (
                    <GrassBlade key={index} offset={blade.offset} opacity={blade.opacity} duration={blade.duration} />
                ))}
            </svg>
        </button>
    );
};


export default GrassButton;
